
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import vSelect from './vselect'
import common from '@/tools/common'
export default {
directives: {
TransferDom
},
components: {
vSelect,
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
Datetime,
XDialog
},
methods: {
doThis: function (index, idlist, name) {
if (name === '内容类别') {
this.contentType = idlist[index]
} else {
this.ruletype = idlist[index]
}
this.queryBtn()
},
handleToggleDrawer (type) {
this.show = true
this.hightype = type
this.$refs.drawerLayout.toggle()
},
chanageSelect (type) {
this.fullsearchtype = type
},
SetFalse () {
this.show = false
},
async queryBtn () {
this.keywordtype = 0
if (this.viewtype === 1) {
this.doQuery()
this.contentType = '列表浏览'
} else {
this.doQueryGroup()
this.contentType = '分组浏览'
}
},
async moreQueryBtn () {
this.keywordtype = 1
if (this.contentType === '列表浏览') {
this.viewtype = 1
} else {
this.viewtype = 2
}
this.keywordtype = 1
if (this.viewtype === 1) {
this.doQuery()
this.contentType = '列表浏览'
} else {
this.doQueryGroup()
this.contentType = '分组浏览'
}
},
async QueryMore (type) {
this.ruletype = type
this.viewtype = 1
this.queryBtn()
},
async next () {
this.currentPage--
await this.doQuery()
},
async perv () {
this.currentPage++
await this.doQuery()
},
async getRulesList () {
const queryPromise = await this.$http.get('/API/FoodsRules/RulesType')
console.log(queryPromise.data)
return queryPromise.data
},
async fullSearchChanage () {
this.fullsearchtype = document.getElementById('searchmor_type').value
this.queryBtn()
},
async orderChanage () {
this.orders = document.getElementById('orders_data').value
this.queryBtn()
},
async viewChange () {
if (this.viewtype === 1) {
this.viewtype = 2
this.doQueryGroup()
} else {
this.doQuery()
this.viewtype = 1
}
console.log(this.viewtype)
},
async doQuery () {
try {
this.$vux.loading.show({ text: ' 数据载入中' })
const queryPromise = await this.$http.get('/API/FoodsRules/GetRuleList'
, {params: {keywordtype: this.keywordtype, ticket: this.ticket, token: this.token, keyword: this.keyword, pageindex: this.currentPage, searchtype: this.fullsearchtype, ordertype: this.orders, pagesize: 10, filename: this.filename, filekeyword: this.filekeyword, title: this.title, area: this.area, years: this.year, department: this.department, effdate: this.effectDate, filetype: this.ruletype}})
this.queryResult = queryPromise.data
if (queryPromise.data.Token !== this.token) {
this.token = queryPromise.data.Token
}
this.$vux.loading.hide()
if (this.queryResult.Data.length === 0) {
this.$vux.alert.show({
title: '通知',
content: '没有符合条件的记录'})
return
}
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}

},
async doFirstQuery () {
this.queryBtn()

},
async doQueryGroup () {
try {
this.$vux.loading.show({ text: ' 数据载入中' })
const queryPromise = await this.$http.get('/API/FoodsRules/GetGroupRuleList'
, {params: {keywordtype: this.keywordtype, ticket: this.ticket, token: this.token, keyword: this.keyword, pageindex: this.currentPage, searchtype: this.fullsearchtype, ordertype: this.orders, pagesize: 10, filename: this.filename, filekeyword: this.filekeyword, title: this.title, area: this.area, years: this.year, department: this.department, effdate: this.effectDate, filetype: this.ruletype}})
this.queryResultGroup = queryPromise.data
if (queryPromise.data.Token !== this.token) {
this.token = queryPromise.data.Token
}
this.$vux.loading.hide()
if (this.queryResultGroup.Data.length === 0) {
this.$vux.alert.show({
title: '通知',
content: '没有符合条件的记录'})
return
}
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}

},
async showDesc (itemid) {
try {
this.$router.push({name: 'FoodRulesSearchDetails', query: {guid: itemid, token: this.token, ticket: this.ticket}})
} catch (err) {
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
},
clear () {
this.year = ''
this.keyword = ''
this.title = ''
this.rno = ''
this.ruletype = ''
this.effectDate = ''
this.department = ''
this.publishDate = ''
this.effect = ''
this.contentType = ''
}
},
data () {
return {
queryResult: {Data: [], TotalPage: 0},
ticket: '',
token: '',
queryResultGroup: {Data: [], TotalPage: 0},
p_code: '',
keyword: '',
fullsearchtype: 0,
orders: 1,
viewtype: 2,
show: true,
hightype: 2,
desc: null,
rno: '',
department: '',
yearList: [],
selects: [0, 0, 0],
year: '',
p_name: '',
ruletype: '',
ruletypeList: ['', '研究报告', '法律法规'],
effect: '',
effectList: ['', '有效', '失效', '部分修改'],
contentType: '',
contenttypeList: ['', '列表浏览', '分组浏览'],
effectDate: null,
publishDate: null,
currentPage: 1,
title: '',
keywordtype: 0,
filename: '',
filekeyword: '',
area: ''
}
},
beforeCreate: function () {
let ss = common.getfoodSession()
if (ss && ss.length > 8) {
} else {
this.$router.push({name: 'FoodRulesLoginPage', query: {UserType: 'type8'}})
}
},
async activated () {


this.ticket = parseInt(new Date().getTime() / 1000).toString()
this.doFirstQuery()
}
}



// WEBPACK FOOTER //
// ./src/components/FoodRulesSearchIndex.vue